var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var CONFIG = {
    /** Logo displayed on the top-left corner */
    logoUrl: require("@/public_assets/game_logo.png"),
    /** Ordered list of availables locales for the UI (corresponding files must exist) */
    locales: [
        { code: "en-gb", name: "English - UK" },
        { code: "en-us", name: "English - US", secondaryCodes: ["en-ca"] },
        { code: "fr-fr", name: "Français" },
        { code: "de-de", name: "Deutsch" },
        { code: "es-es", name: "Español" },
        { code: "it-it", name: "Italiano" },
        { code: "pl-pl", name: "Polski" },
        { code: "pt-br", name: "Português" },
        { code: "ja-jp", name: "日本語" },
        { code: "ko-kr", name: "한국어" },
        { code: "zh-tw", name: "繁體中文" },
        { code: "zh-cn", name: "简体中文" },
        // Disabled locales
        // { code: "ru", name: "Русский" },
    ],
    localeSelectorEnabled: true,
    buyButtonEnabled: true,
    zoomControlledVolumeEnabled: false,
    skipIntroAnimation: true,
    /** 3D File data */
    models: {
        /** Artbook scene (book & table) */
        artbook: {
            /** 3D Model file */
            file: require("@/private_assets/skull-and-bones/3d/scene.glb"),
            transform: {
                debug: false,
                scale: 0.008969999999981305,
                position: [-0.3755000000000002, -13.775099999999668, 11.34322222222229],
            },
            /** Name of the camera node in the scene */
            camera: "Camera",
            /** Name of the book cover mesh (optional) */
            // top: "COVER",
            /** Name of the overlay shadow (optional) */
            // shadowOverlay: "SHADOW_OVERLAY",
            pageAnchor: "PAGE_RIGHT",
            // pageAnchor: [
            //   [0.49, 0.65],
            //   [0.4, 0],
            // ],
            /** List of the shadow meshes */
            shadows: [
            // "SHADOW_OVERLAY",
            // "SHADOW_OVERLAY1",
            // "SHADOW_OVERLAY2",
            // "SHADOW_OVERLAY_2",
            // "SHADOW_OVERLAY3",
            // "SHADOW_OVERLAY4",
            // "SHADOW_OVERLAY5",
            // "SHADOW_OVERLAY6",
            // "SHADOW_OVERLAY7",
            ],
            /** List of the meshes with transparency */
            transparentNodes: [
                //
                // "RS_Poster",
                "BOOK_SHADOW",
            ],
            doubleSideNode: [
            //
            // "RS_Gauntlet",
            ],
        },
        /** Single page scene */
        page: {
            /** 3D model file */
            file: require("@/private_assets/skull-and-bones/3d/page.glb"),
            /** Parent bone */
            bone: "Bone001",
            /** Mesh */
            plane: "Page",
            /** Durations in seconds of the page animations */
            animationsDurations: {
                /** Page turning left (backward) animation */
                toLeft: 1.8,
                /** Page turning right (forward) animation */
                toRight: 1.8,
                /** Fold animation on hover (leave at 0 if none) */
                fold: 0.8,
            },
        },
        /** Start position of the camera, after the introduction animation */
        initialCameraPosition: {
            x: 0,
            y: 0,
            zoom: -0.2,
        },
    },
    /** Pages configuration */
    pages: {
        /** Displayed number of the first page (the one on the left when at the summary) */
        firstPageNumber: 2,
        /** Resolution of the original page model textures (from the Settler), impact ratio */
        modelRes: { width: 3508, height: 2480 },
        /** Resolution of the new pages (tip: to rescale more easily, keep the same width or height than the model res) */
        targetRes: { width: 3425, height: 3425 },
        /** Scale of the page model */
        scale: 0.0016,
        /** Move the position of the pages so that it's aligned with the book (relative to the center of the scene) */
        offset: { x: 0, y: 0.085 },
    },
    /** Artbook textures */
    textures: {
        /** Textures used for empty pages (before their content is displayed) */
        emptyPage: {
            left: require("@/private_assets/skull-and-bones/artbook/white.png"),
            right: require("@/private_assets/skull-and-bones/artbook/white.png"),
        },
        pageAmbianceLayer: {
            left: require("@/private_assets/skull-and-bones/artbook/white.png"),
            right: require("@/private_assets/skull-and-bones/artbook/white.png"),
        },
        /** Root folder of the pages textures (containing locales folders) */
        folder: require.context("@/private_assets/skull-and-bones/artbook/?sizes[]=162&sizes[]=512&sizes[]=2048", true),
        /** List of available languages for the artbook content */
        locales: [
            {
                /** Locale name (must match exactly the folder containing the textures!) */
                name: "en",
                /** Path to the cover texture */
                bookCover: require("@/private_assets/skull-and-bones/artbook/BOOK_COVER_en.jpg"),
            },
        ],
        /** Locale used when the website lang isn't available in the artbook textures */
        defaultLocale: "en",
        /** Pattern of the files names */
        filePattern: /(\d+)\.jpg/, // [NUMBER]_[name].jpg
    },
    /** Sounds played in the Artbook */
    sfx: {
        /** Emplacement of the SFX files folder */
        folder: require.context("@/private_assets/sfx/"),
        /** Pattern of the files names */
        namePattern: function (f) {
            var pagesDefs = __spreadArray([], __read(f.matchAll(/(\d+)-(\d+)\./g)), false);
            if (pagesDefs.length === 0) {
                throw new Error("Invalid sfx filename: ".concat(f));
            }
            return {
                pages: pagesDefs.map(function (e) { return parseInt(e[1]); }),
                locale: null,
            };
        },
    },
    /** Clickable area used to turn pages */
    pageTurnArea: {
        width: 5.8,
        height: 3.9,
        offset: 3.1,
        /** Enable to see the areas in the scene */
        debug: false,
    },
    /** Configuration of the summary page */
    summary: {
        /** Set to true to see the clickable areas */
        debug: false,
        /** Circle drawn around pages number */
        circle: {
            /** Scale of the sprite */
            scale: [0.16, 0.16],
            /** Default position of the page number in lines, relatively to the border of its area (top, right bottom, left) */
            position: { centerX: 0, centerY: -0.003 },
            /** Sprite sheet of the circle */
            sprite: require("@/private_assets/skull-and-bones/artbook/SUMMARY_sprite.png"),
            /** Animation configuration */
            animation: {
                orientation: "vertical",
                /** Number of frames */
                frames: 23,
                /** Duration of the animation */
                duration: 700,
            },
        },
        /** List of clickable lines in the summary */
        items: function () {
            var w = window;
            var BASE_CONFIG = {
                BIG_LINE: { x: 1, width: 1.95, height: 0.16 },
                GAP: 0.115,
                SMALL_LINE: { x: 1.15, width: 1.8, height: 0.1 },
                SMALL_X: 0,
                START_Y: -0.56,
            };
            if (w.ITEMS_CONFIG == null) {
                w.ITEMS_CONFIG = BASE_CONFIG;
            }
            var CONFIG = w.ITEMS_CONFIG || BASE_CONFIG;
            var res = [];
            var pos = CONFIG.START_Y;
            function pushSmall(page) {
                res.push({
                    /** Position (for each locale) of the top left corner */
                    position: [{ value: { x: CONFIG.SMALL_LINE.x, y: pos } }],
                    /** Dimensions (for each locale) of the clickable zone */
                    size: [{ value: CONFIG.SMALL_LINE }],
                    /** Circle position can be overriden for specific lines and locales */
                    // circlePosition: [{ value: { right: 0.1, bottom: 0.2 } }],
                    /** Page that item opens */
                    target: page,
                });
                pos += CONFIG.SMALL_LINE.height;
            }
            function pushBig(page) {
                res.push({
                    /** Position (for each locale) of the top left corner */
                    position: [{ value: { x: CONFIG.BIG_LINE.x, y: pos } }],
                    /** Dimensions (for each locale) of the clickable zone */
                    size: [{ value: CONFIG.BIG_LINE }],
                    /** Circle position can be overriden for specific lines and locales */
                    // circlePosition: [{ value: { right: 0.1, bottom: 0.2 } }],
                    circleScale: [{ value: [1.1, 1.5] }],
                    /** Page that item opens */
                    target: page,
                });
                pos += CONFIG.BIG_LINE.height;
            }
            function pushGap() {
                pos += CONFIG.GAP;
            }
            pushBig(4);
            pushSmall(6);
            pushSmall(18);
            pushSmall(32);
            pushGap();
            pushBig(46);
            pushSmall(48);
            pushSmall(68);
            pushSmall(72);
            pushGap();
            pushBig(84);
            pushSmall(86);
            pushSmall(104);
            pushSmall(108);
            pushGap();
            pushBig(126);
            pushSmall(128);
            pushSmall(132);
            pushSmall(142);
            pushGap();
            return res;
        },
    },
    /** Fade in shader used to display pages */
    fadeInShader: {
        /** Hook to call to build shaders materials */
        // hook: null as any,
        /** Fade in duration */
        duration: 2,
        /** Fade in delay after the page turns */
        delay: 0.7,
    },
    /** Soundtrack files */
    soundtrack: {
        /** Folder containing the audio files */
        folder: require.context("@/private_assets/skull-and-bones/soundtrack"),
        /** List of tracks */
        tracks: [
        // { title: "Bahjat Alqamar (Moon Elation)", duration: 1 * 60 + 33 },
        // { title: "Ahlamun wa Amani (Hopes And Dreams)", duration: 2 * 60 + 2 },
        // { title: "Mughamara (Adventure)", duration: 1 * 60 + 24 },
        // { title: "Nuzha Fi Assooq (Market Stroll)", duration: 1 * 60 + 19 },
        // { title: "Mahboobati (My Beloved)", duration: 1 * 60 + 35 },
        ],
    },
    /** Downloadable content */
    downloads: {
        /** Archive of the soundtrack to download */
        // soundtrack: require("@/private_assets/skull-and-bones/downloads/Assassin's Creed Mirage - Soundtrack.zip"),
        /** Artbook PDF files */
        artbook: {
            /** parent folder containing the locales */
            folder: require.context("@/private_assets/skull-and-bones/downloads/artbook/", true, /\.(zip|pdf)/i),
            recommendedQuality: "hd",
            namePattern: function (file) {
                var match = file.match(/(\w{2}) - (ld|hd|4k)\.(zip|pdf)/i);
                if (match == null)
                    throw new Error("Invalid file name: " + file);
                return {
                    locale: match[1].toLowerCase(),
                    quality: match[2].toLowerCase(),
                };
            },
        },
    },
    /** Rating displayed in the footer, by locale */
    ratings: {
        "pegi-18": {
            file: require("@/public_assets/rating/pegi-18.png"),
            alt: "PEGI 18",
        },
        "pegi-16": {
            file: require("@/public_assets/rating/pegi-16.png"),
            alt: "PEGI 16",
        },
        "pegi-12": {
            file: require("@/public_assets/rating/pegi-12.png"),
            alt: "PEGI 12",
        },
        "esrb-m": {
            file: require("@/public_assets/rating/esrb-m.svg?resource"),
            alt: "ESRB M",
        },
        "esrb-teen": {
            file: require("@/public_assets/rating/esrb-teen.svg?resource"),
            alt: "ESRB teen",
        },
        "cero-a": {
            file: require("@/public_assets/rating/cero-a.svg?resource"),
            alt: "CERO A",
        },
        "cero-d": {
            file: require("@/public_assets/rating/cero-d.svg?resource"),
            alt: "CERO D",
        },
        "classind-16": {
            file: require("@/public_assets/rating/classind-16.png"),
            alt: "ClassInd 16",
        },
        "classind-14": {
            file: require("@/public_assets/rating/classind-14.svg?resource"),
            alt: "ClassInd 14",
        },
        "classind-12": {
            file: require("@/public_assets/rating/classind-12.png"),
            alt: "ClassInd 12",
        },
        "usk-18": {
            file: require("@/public_assets/rating/usk-18.svg?resource"),
            alt: "USK 18",
        },
        "usk-16": {
            file: require("@/public_assets/rating/usk-16.svg?resource"),
            alt: "USK 16",
        },
        "usk-6": {
            file: require("@/public_assets/rating/usk-6.svg?resource"),
            alt: "USK 6",
        },
        "csrr-12": {
            file: require("@/public_assets/rating/csrr-12.svg?resource"),
            alt: "CSRR 12+",
        },
        "csrr-15": {
            file: require("@/public_assets/rating/csrr-15.svg?resource"),
            alt: "CSRR 15+",
        },
        "csrr-18": {
            file: require("@/public_assets/rating/csrr-18.svg?resource"),
            alt: "CSRR 18+",
        },
        "grac-12": {
            file: require("@/public_assets/rating/grac-12.svg?resource"),
            alt: "GRAC 12+",
        },
        "grac-15": {
            file: require("@/public_assets/rating/grac-15.svg?resource"),
            alt: "GRAC 15+",
        },
        "grac-18": {
            file: require("@/public_assets/rating/grac-18.svg?resource"),
            alt: "GRAC 18+",
        },
        "rars-18": {
            file: require("@/public_assets/rating/rars-18.svg?resource"),
            alt: "RARS 18",
        },
        "rars-16": {
            file: require("@/public_assets/rating/rars-16.svg?resource"),
            alt: "RARS 16",
        },
        "cadpa-12": {
            file: require("@/public_assets/rating/cadpa-12.png"),
            alt: "CADPA 12+",
        },
    },
    analytics: {
        brandName: "avatar",
        mdmBrandId: "422",
        installmentName: "frontiers of pandora",
        mdmInstallmentId: "5291",
        siteName: "avatar frontiers of pandora : artbook",
    },
};
